import { z } from 'zod'

import { EmptyArraySchema } from '../base'

import { TypicalTemplateItemSchema } from './typicalTemplateItem'

export const SequenceItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  messages: TypicalTemplateItemSchema,
  template_installation_id: z.number().nullable(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const GrowthToolItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  template_installation_id: z.number().nullable(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  has_fb_channel: z.boolean(),
  has_wa_channel: z.boolean(),
  has_ig_channel: z.boolean(),
  has_tg_channel: z.boolean(),
  has_tt_channel: z.boolean(),
  has_email_channel: z.boolean(),
  has_sms_channel: z.boolean(),
  has_webchat_channel: z.boolean(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const KeywordItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  template_installation_id: z.number().nullable(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  has_fb_channel: z.boolean(),
  has_wa_channel: z.boolean(),
  has_ig_channel: z.boolean(),
  has_tg_channel: z.boolean(),
  has_tt_channel: z.boolean(),
  has_email_channel: z.boolean(),
  has_sms_channel: z.boolean(),
  has_webchat_channel: z.boolean(),
  keywords: z.array(z.string()),
  keyword_rules: z.array(
    z.object({
      keywords: z.array(z.string()),
      condition: z.string(),
    }),
  ),
  is_system: z.boolean(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const IntentItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  template_installation_id: z.number().nullable(),
  is_pro: z.boolean(),
  is_ai_addon: z.boolean(),
  has_fb_channel: z.boolean(),
  has_wa_channel: z.boolean(),
  has_ig_channel: z.boolean(),
  has_tg_channel: z.boolean(),
  has_tt_channel: z.boolean(),
  has_email_channel: z.boolean(),
  has_sms_channel: z.boolean(),
  has_webchat_channel: z.boolean(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const FlowItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  template_installation_id: z.number().nullable(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  has_fb_channel: z.boolean(),
  has_wa_channel: z.boolean(),
  has_ig_channel: z.boolean(),
  has_tg_channel: z.boolean(),
  has_tt_channel: z.boolean(),
  has_email_channel: z.boolean(),
  has_sms_channel: z.boolean(),
  has_webchat_channel: z.boolean(),
  is_ai_addon: z.boolean(),
  is_draft: z.boolean(),
  has_message_tags: z.boolean(),
  has_one_time_notify_messages: z.boolean(),
  folder_path: z.string(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const GeneralItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  template_installation_id: z.number().nullable(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const IntegrationItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  is_pro: z.boolean(),
  template_installation_id: z.number().nullable(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const TriggerItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  template_installation_id: z.number().nullable(),
  corrupted_messages: z.array(z.string()).optional(),
})

export const ExternalTriggerItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  is_corrupted: z.boolean(),
  is_pro: z.boolean(),
  template_installation_id: z.number().nullable(),
  corrupted_messages: z.array(z.string()).optional(),
})
const TemplateInstallationsDescriptionSchema = z.object({
  guideLink: z.string().nullish(),
  summary: z.string().nullish(),
  videoGuideLink: z.string().nullish(),
})

export const TemplateInstallationsItemSchema = z.object({
  installation_id: z.number(),
  author_name: z.string(),
  author_user_id: z.number().nullish(),
  description: TemplateInstallationsDescriptionSchema.nullable(),
  icon: z.string().nullish(),
  is_protected: z.boolean(),
  template_id: z.number(),
  template_url: z.string().nullable(),
  title: z.string(),
  version_id: z.number(),
  template_avatar: z.object({
    avatar_url_100x100: z.string().nullish(),
    color: z.string(),
  }),
  details: z.object({
    template_root_folder_id: z.number().nullable(),
    installation_settings: z.object({
      mapping_settings: z
        .object({
          default_reply: z.boolean().optional(),
          main_menu: z.boolean().optional(),
          welcome_message: z.boolean().optional(),
        })
        .or(EmptyArraySchema),
      replace_settings: z.object({
        default_reply: z.boolean().optional(),
        main_menu: z.boolean().optional(),
        welcome_message: z.boolean().optional(),
      }),
      template_fields_installation_map: z.looseObject({}).or(EmptyArraySchema),
    }),
  }),
})

export const ModelList = [
  SequenceItemSchema,
  GrowthToolItemSchema,
  KeywordItemSchema,
  IntentItemSchema,
  FlowItemSchema,
  GeneralItemSchema,
  IntegrationItemSchema,
  TriggerItemSchema,
  ExternalTriggerItemSchema,
]
